import { captureException } from '@sentry/browser';

const non404ErrorRegex = /^((?!404).)*$/;

export default function containsUnexpectedRoostError(controlPipeline) {
  if (controlPipeline.error) {
    captureException(controlPipeline.error);
    return true;
  }

  if (controlPipeline.errors && non404ErrorRegex.test(controlPipeline.errors.message)) {
    captureException(controlPipeline.errors);
    return true;
  }

  return false;
}
